import React, { useState, useRef, useEffect } from "react";
import html2pdf from "html2pdf.js";
import { useParams } from "react-router-dom";

import axios from "axios";
import config from "../../config"; 

const CommonDueLetter = () => {
  const [activeTab, setActiveTab] = useState("Applicant");
  const letterRef = useRef();

  const getPdfOptions = () => ({
    margin:       [0.2, 0.2, 0.2, 0.2], // 0.2 inch margin all around
    filename:     `Due_Reminder_${activeTab}.pdf`,
    image:        { type: 'jpeg', quality: 0.98 },
    html2canvas:  { scale: 2, useCORS: true, letterRendering: true },
    jsPDF:        { unit: 'in', format: 'a4', orientation: 'portrait' }
  });

  const handleDownloadPdf = () => {
    html2pdf().set(getPdfOptions()).from(letterRef.current).save();
  };

  const handlePreview = () => {
    html2pdf().set(getPdfOptions()).from(letterRef.current).outputPdf('bloburl').then((url) => {
      window.open(url, '_blank');
    });
  };

  const tabs = ["Applicant", "Co-applicant", "Guarantor"];

    const { agreementNo } = useParams();
    const decodedAgreementNo = atob(agreementNo);

    const [dueData, setDueData] = useState(null);
    const [loading, setLoading] = useState(true);
    
        useEffect(() => {
        getDueLetterData();
        }, []);

        const getDueLetterData = async () => {
        try {
            setLoading(true);

            const formData = new FormData();
            formData.append("agreement_no", decodedAgreementNo);

            const res = await axios.post(
            `${config.API_BASE_URL}get_due_letter_data`,
            formData
            );

            if (res.data.status) {
            setDueData(res.data);
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
        };

   if (loading) {
    return <div>Loading...</div>;
   }

   const current = activeTab === "Applicant" ? dueData?.applicant : activeTab === "Co-applicant" ? dueData?.co_applicants?.[0] : dueData?.guarantors?.[0];


  return (
    <div style={{ backgroundColor: "#ffffff", minHeight: "100vh", fontFamily: "Arial, sans-serif" }}>
      {/* Header section */}
      <div style={{ padding: "20px 40px" }}>
        <h2 style={{ fontSize: "22px", fontWeight: "bold", margin: "0 0 20px 0" }}>Due Reminder Notice</h2>
        
        <div style={{ backgroundColor: "#f9fafb", borderRadius: "8px", display: "flex", padding: "0 20px", borderBottom: "1px solid #eee" }}>
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              style={{
                background: "transparent",
                border: "none",
                outline: "none",
                padding: "15px 25px",
                cursor: "pointer",
                color: activeTab === tab ? "#00b8d4" : "#637381",
                borderBottom: activeTab === tab ? "3px solid #00b8d4" : "3px solid transparent",
                fontWeight: activeTab === tab ? "bold" : "500",
                fontSize: "15px",
                transition: "all 0.2s"
              }}
            >
              {tab}
            </button>
          ))}
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: "15px", marginTop: "20px", marginBottom: "20px" }}>
          <button 
            onClick={handlePreview}
            style={{ backgroundColor: "#00b8d4", color: "#fff", border: "none", padding: "10px 24px", borderRadius: "6px", fontSize: "10px", fontWeight: "bold", cursor: "pointer", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}
          >
            PREVIEW
          </button>
          <button 
            onClick={handleDownloadPdf}
            style={{ backgroundColor: "#ffb300", color: "#fff", border: "none", padding: "10px 24px", borderRadius: "6px", fontSize: "10px", fontWeight: "bold", cursor: "pointer", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}
          >
            DOWNLOAD PDF
          </button>
        </div>
      </div>

      {/* Letter Content Container */}
      <div style={{ display: "flex", justifyContent: "center", paddingBottom: "60px" }}>
        {/* We use a fixed width and max-height so it perfectly fits A4 dimensions (720px wide, ~1000px high max) */}
        <div 
          ref={letterRef} 
          style={{ 
            width: "740px", 
            border: "1px solid #000", 
            padding: "30px 40px", 
            backgroundColor: "#fff", 
            boxSizing: "border-box", 
            color: "#000", 
            fontSize: "12px", 
            lineHeight: "1.5" 
          }}
        >
          
          {/* Logo & Company Header */}
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginBottom: "8px" }}>
               <img src="/assets/ckern-logo.png" alt="cKers Finance" style={{ height: "55px" }} onError={(e) => { e.target.style.display = 'none'; }} />
            </div>
            <div style={{ fontWeight: "bold", fontSize: "15px", marginBottom: "4px", color: "#003366" }}>cKers Finance Private Limited</div>
            <div style={{ fontSize: "11px", fontWeight: "500" }}>Building No-24-30,First Floor, Okhla Industrial Estate,Phase-III, New Delhi 110020, INDIA</div>
            <div style={{ fontSize: "11px", fontWeight: "500" }}>Phone +91-11-41070629 contact@ckersfinance.in</div>
          </div>



            {activeTab === "Applicant" ? (
            <>
                <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "15px",
                }}
                >
                <div>
                    <div style={{ fontWeight: "bold", marginBottom: "2px" }}>To,</div>

                    <div style={{ fontWeight: "bold", marginBottom: "6px" }}>
                    {current?.name}
                    </div>

                    <div>Address - {current?.full_address}</div>

                    <div>Mobile No - {current?.mobile}</div>

                    <div style={{ marginTop: "12px" }}>
                    Vehicle No - {current?.vehicle_no}
                    </div>
                </div>

                <div>
                    <div style={{ fontWeight: "bold" }}>
                    Date: {current?.date}
                    </div>
                </div>
                </div>

                <div style={{ marginBottom: "15px", textAlign: "justify" }}>
                आपका ऋण खाता में रु. {current?.TotalLoanOverdueAmount} की देय राशि
                बकाया है।
                <br />
                कृपया डिमांड ड्राफ्ट /RTGS/ UPI/ NEFT/ /चेक द्वारा भुगतान कर सकते हैं
                (बैंक: ICICI Bank, शाखा, दिल्ली, खाता संख्या: 182005001431). कृपया
                जमा की गई राशि को वाहन नंबर और जमा की तारीख का उल्लेख करते हुए मोबाइल
                नंबर 88882247464 पर सूचित करें। समझौते के नियमों और शर्तों के अनुसार
                संग्रह शुल्क और देर से भुगतान के लिए अतिरिक्त शुल्क और अन्य शुल्क अलग
                से लिया जाएगा।
                </div>

                <table
                style={{
                    borderCollapse: "collapse",
                    width: "65%",
                    marginBottom: "15px",
                    fontSize: "11px",
                    border: "1px solid #000",
                }}
                >
                <tbody>
                    <tr>
                    <td
                        style={{
                        border: "1px solid #000",
                        padding: "5px 8px",
                        fontWeight: "bold",
                        }}
                    >
                        Agreement No
                    </td>
                    <td
                        style={{
                        border: "1px solid #000",
                        padding: "5px 8px",
                        textAlign: "right",
                        }}
                    >
                        {current?.agreement_no}
                    </td>
                    </tr>

                    <tr>
                    <td
                        style={{
                        border: "1px solid #000",
                        padding: "5px 8px",
                        fontWeight: "bold",
                        }}
                    >
                        Registration Number
                    </td>
                    <td
                        style={{
                        border: "1px solid #000",
                        padding: "5px 8px",
                        textAlign: "right",
                        }}
                    >
                        {current?.vehicle_no}
                    </td>
                    </tr>

                    <tr>
                    <td
                        style={{
                        border: "1px solid #000",
                        padding: "5px 8px",
                        fontWeight: "bold",
                        }}
                    >
                        Model
                    </td>
                    <td
                        style={{
                        border: "1px solid #000",
                        padding: "5px 8px",
                        textAlign: "right",
                        textTransform: "uppercase",
                        }}
                    >
                        {current?.model}
                    </td>
                    </tr>

                    <tr>
                    <td
                        style={{
                        border: "1px solid #000",
                        padding: "5px 8px",
                        fontWeight: "bold",
                        }}
                    >
                        Agreement Date
                    </td>
                    <td
                        style={{
                        border: "1px solid #000",
                        padding: "5px 8px",
                        textAlign: "right",
                        }}
                    >
                        {current?.agreement_date}
                    </td>
                    </tr>

                    <tr>
                    <td
                        style={{
                        border: "1px solid #000",
                        padding: "5px 8px",
                        fontWeight: "bold",
                        }}
                    >
                        Total Number of EMI Dues
                    </td>
                    <td
                        style={{
                        border: "1px solid #000",
                        padding: "5px 8px",
                        textAlign: "right",
                        }}
                    >
                        {current?.emi_due_count}
                    </td>
                    </tr>

                    <tr>
                    <td
                        style={{
                        border: "1px solid #000",
                        padding: "5px 8px",
                        fontWeight: "bold",
                        }}
                    >
                        Instalment Amount
                    </td>
                    <td
                        style={{
                        border: "1px solid #000",
                        padding: "5px 8px",
                        textAlign: "right",
                        }}
                    >
                        ₹ {current?.emi_amount}
                    </td>
                    </tr>

                    <tr>
                    <td
                        style={{
                        border: "1px solid #000",
                        padding: "5px 8px",
                        fontWeight: "bold",
                        }}
                    >
                        Last Receipt Date
                    </td>
                    <td
                        style={{
                        border: "1px solid #000",
                        padding: "5px 8px",
                        textAlign: "right",
                        }}
                    >
                        {current?.last_receipt_date}
                    </td>
                    </tr>

                    <tr>
                    <td
                        style={{
                        border: "1px solid #000",
                        padding: "5px 8px",
                        fontWeight: "bold",
                        }}
                    >
                        Total Dues
                    </td>
                    <td
                        style={{
                        border: "1px solid #000",
                        padding: "5px 8px",
                        textAlign: "right",
                        }}
                    >
                        ₹ {current?.TotalLoanOverdueAmount}
                    </td>
                    </tr>
                </tbody>
                </table>
                <div style={{ marginBottom: "15px", textAlign: "justify" }}>
                    कृपया उपरोक्त शेष राशि तीन (3) दिनों के भीतर जमा करें या किसी भी कार्य दिवस पर
                    सुबह 09:30 बजे से शाम 6:30 बजे तक हमारे कार्यालय से संपर्क करें और हमें सलाह दें
                    कि हम आपका भुगतान कब प्राप्त करने की उम्मीद कर सकते हैं या क्या आप अन्य वित्तीय
                    भुगतान करना चाहते हैं तो कर सकते हैं।
                    </div>

                    <div style={{ marginBottom: "15px", textAlign: "justify" }}>
                    हम आपको यह भी बताना चाहते हैं कि यदि आपकी EMI या EMI का भुगतान न करने के कारण
                    उत्पन्न कोई अन्य शुल्क महीने के अंत तक भुगतान नहीं किया गया है तो हम गारंटर और
                    सह-आवेदक के साथ आपके ऋण खाते की लंबित राशि की ब्यूरो में RBI दिशानिर्देशों के
                    अनुसार रिपोर्ट करेंगे।
                    </div>

                    <div style={{ marginBottom: "30px" }}>
                    यदि भुगतान किया गया है तो कृपया इसे अनदेखा करें।
                    </div>

                    <div>
                    <div style={{ fontWeight: "bold", marginBottom: "40px" }}>
                        For cKers Finance Private Limited
                    </div>

                    {/* Agar signature image hai to yahan lagao */}
                    {/* <img src="/assets/signature.png" style={{ width: "120px", marginBottom: "5px" }} /> */}

                    <div style={{ fontWeight: "bold" }}>
                        Manager/Authorized Signatory
                    </div>
                 </div>
            </>
            ) : (
            <>
                <div
                style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    marginBottom: "15px",
                    fontSize: "13px",
                    textDecoration: "underline",
                }}
                >
                Due Reminder Letter To{" "}
                {activeTab === "Co-applicant" ? "Co-Applicant" : "Guarantor"}
                </div>

                <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "15px",
                }}
                >
                <div>
                    <div style={{ fontWeight: "bold", marginBottom: "2px" }}>
                    To,
                    </div>

                    <div style={{ fontWeight: "bold", marginBottom: "6px" }}>
                    {current?.name}
                    </div>

                    <div>Address - {current?.full_address}</div>

                    <div>Mobile No - {current?.mobile}</div>
                </div>

                <div style={{ width: "140px" }}>
                    <div style={{ fontWeight: "bold" }}>
                    Date: {current?.date}
                    </div>
                </div>
                </div>

                <div style={{ marginBottom: "15px" }}>
                <div>
                    Reference : {dueData?.applicant?.name}
                </div>

                <div>
                    Vehicle No : {current?.vehicle_no},
                    {" "}Model : {current?.model},
                    {" "}Over Due Amount : ₹{current?.TotalLoanOverdueAmount}
                </div>
                </div>

                <div style={{ marginBottom: "15px", textAlign: "justify" }}>
                आपका आवेदक के ऋण खाते में रु.
                {current?.TotalLoanOverdueAmount}
                {" "}की देय राशि बकाया है।
                </div>

                <div style={{ marginBottom: "15px", textAlign: "justify" }}>
                हमने आवेदक को उसकी बकाया राशि के साथ-साथ संग्रह शुल्क और देर से
                भुगतान के लिए अतिरिक्त किराया शुल्क और समझौते के नियमों और शर्तों
                के अनुसार अन्य शुल्कों के बारे में सूचित कर दिया है।
                </div>

                <div style={{ marginBottom: "15px", textAlign: "justify" }}>
                कृपया आवेदक को उपरोक्त शेष राशि तीन (3) दिनों के भीतर जमा करें
                अथवा किसी भी कार्य दिवस पर सुबह 09:30 बजे से शाम 6:30 बजे तक
                हमारे कार्यालय से संपर्क करें।
                </div>

                <div style={{ marginBottom: "15px", textAlign: "justify" }}>
                हम आपको यह भी बताना चाहते हैं कि आपका आवेदक यदि EMI का भुगतान
                नहीं करता है तो गारंटर एवं सह-आवेदक के साथ आपके ऋण खाते की
                लंबित राशि ब्यूरो में रिपोर्ट की जा सकती है।
                </div>

                <div style={{ marginBottom: "30px" }}>
                यदि भुगतान किया गया है तो कृपया इसे अनदेखा करें।
                </div>

                <div>
                <div style={{ fontWeight: "bold", marginBottom: "40px" }}>
                    For cKers Finance Private Limited
                </div>

                <div style={{ fontWeight: "bold" }}>
                    Manager/Authorized Signatory
                </div>
                </div>
            </>
            )}



        </div>
      </div>
    </div>
  );
};

export default CommonDueLetter;